

document.querySelectorAll('.customer_review_splide').forEach((coltab) => {
  const colTab = new Splide( coltab, {
    type   : 'slide',
    gap: '3rem',
    rewind : true,
    perPage: 3,
    pagination : false ,
    breakpoints: {
      989: {
        perPage: 2,
      },
      749: {
        perPage: 1,
        padding:'20%',
        start:2
      }
    },
  });
 
  const bar = colTab.root.querySelector('.my-slider-progress-bar');
  if (bar) {
    colTab.on('mounted move', function () {
      const end = colTab.Components.Controller.getEnd() + 1;
      const rate = Math.min((colTab.index + 1) / end, 1);
      bar.style.width = `${100 * rate}%`;
    });
  }

  colTab.mount();
 
 

});